import PropTypes from "prop-types";
import React from "react";

function SearchBanner({ title, icon, content }) {
  return (
    <div id="searchBanner" className="provider-search-container">
      <div className="container-fluid">
        <div className="argusnetwork-menu">
          <div className="provider-search-container">
            <ol className="search-breadcrumb breadcrumb-arrow">
              <li>
                <a href="#/home">
                  <i className={icon} aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a>
                  <b className="ng-binding">{title}</b>
                </a>
              </li>
            </ol>
          </div>
        </div>
        <div className="argusnetwork">
          <div className="argusnetwork-desc container">
            <h3>{title}</h3>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}

SearchBanner.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
};

export default SearchBanner;
